import { Phone } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="relative py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <div className="relative mx-auto max-w-sm">
            <div data-testid="founder-photo" className="overflow-hidden rounded-[2rem] border border-black/10">
              <img
                src="/founder-braidon.png"
                alt="Braidon Bencharski, founder of SnackSavvy Vending Services"
                loading="lazy"
                className="aspect-[4/5] w-full object-cover object-top"
              />
            </div>
            <div
              aria-hidden="true"
              className="absolute -bottom-5 -right-5 -z-10 h-full w-full rounded-[2rem] border border-[#C9A227]/40"
            />
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>Meet the owner</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-[#16120E] sm:text-4xl lg:text-5xl">
              Hi, I'm Braidon — when you call, you get me.
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-600 sm:text-lg">
              SnackSavvy started with a simple belief: every workplace deserves a
              great breakroom, and no manager should have to babysit it. As a new,
              owner-operated company, I personally handle the site visits, the
              installation and the service calls — and as we grow, that
              hands-on care is the standard we hire for.
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-stone-600 sm:text-lg">
              Founding locations don't just get a machine. They get a partner who
              answers the phone, remembers your team's favourite snacks, and
              shows up when promised.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <span className="rounded-full border border-[#C9A227]/40 bg-[#C9A227]/10 px-4 py-2 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-[#7A6215]">
                Braidon Bencharski · Founder
              </span>
              <a
                href="tel:+12042186681"
                className="inline-flex items-center gap-2 text-sm font-semibold text-[#1B365D] transition-colors hover:text-[#2A4A73]"
              >
                <Phone className="h-4 w-4" />
                204-218-6681 — my direct line
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
